import config from '@feature-config/riya/controller/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import { ControllerFeature } from './ControllerFeature';

const controllerFeature: FeatureModule = createFeatureModule(
  config,
  ControllerFeature,
  'riya/controller'
);

export default controllerFeature;
